import { CREATE_RATING, CREATE_RATING_SUCCESS, GET_ALL_BADGES, GET_ALL_BADGES_SUCCESS, GET_GAMIFICATION_CRITERIA, GET_GAMIFICATION_CRITERIA_SUCCESS, GET_GAMIFICATION_CRITERIA_USER, GET_GAMIFICATION_CRITERIA_USER_SUCCESS, GET_MY_RATING, GET_MY_RATING_SUCCESS, GET_RATING_BY_ID, GET_RATING_BY_ID_SUCCESS, GET_REPORT_HISTORY, GET_REPORT_HISTORY_BY_ID, GET_REPORT_HISTORY_BY_ID_SUCCESS, GET_REPORT_HISTORY_SUCCESS, GET_UNLOCKED_BADGE, GET_UNLOCKED_BADGE_SUCCESS, GET_WORKER_PERFORMANCE, GET_WORKER_PERFORMANCE_SUCCESS } from "../storeTypes"

export const getCriteriabyTaskId = (payload) => {
    return {
        type: GET_RATING_BY_ID,
        payload: payload
    }
}
export const getCriteriabyTaskIdSuccess = (payload) => {
    return {
        type: GET_RATING_BY_ID_SUCCESS,
        payload: payload
    }
}
export const createRating = (payload, callBack) => {
    return {
        type: CREATE_RATING,
        payload: payload,
        callBack
    }
}
export const createRatingSuccess = (payload) => {
    return {
        type: CREATE_RATING_SUCCESS,
        payload: payload
    }
}
export const getMyReviews = (payload) => {
    return {
        type: GET_MY_RATING,
        payload: payload
    }
}
export const getMyReviewsSuccess = (payload) => {
    return {
        type: GET_MY_RATING_SUCCESS,
        payload: payload
    }
}

//Report History
export const getReportHistory = (payload) => {
    return {
        type: GET_REPORT_HISTORY,
        payload: payload,

    }
}
export const getReportHistorySuccess = (payload) => {
    return {
        type: GET_REPORT_HISTORY_SUCCESS,
        payload: payload
    }
}

export const getReportHistoryById = (payload) => {
    return {
        type: GET_REPORT_HISTORY_BY_ID,
        payload: payload,

    }
}
export const getReportHistoryByIdSuccess = (payload) => {
    return {
        type: GET_REPORT_HISTORY_BY_ID_SUCCESS,
        payload: payload
    }
}

export const getGamificationCriteria = (payload) => {
    return {
        type: GET_GAMIFICATION_CRITERIA,
        payload
    }
}

export const getGamificationCriteriaSuccess = (payload) => {
    return {
        type: GET_GAMIFICATION_CRITERIA_SUCCESS,
        payload
    }
}

export const getAllBadges = (payload) => {
    return {
        type: GET_ALL_BADGES,
        payload
    }
}

export const getAllBadgesSuccess = (payload) => {
    return {
        type: GET_ALL_BADGES_SUCCESS,
        payload
    }
}
export const getGamificationCriteriaUser = (payload) => {
    return {
        type: GET_GAMIFICATION_CRITERIA_USER,
        payload
    }
}

export const getGamificationCriteriaUserSuccess = (payload) => {
    return {
        type: GET_GAMIFICATION_CRITERIA_USER_SUCCESS,
        payload
    }
}
export const getUnlockedBadges = (payload) => {
    return {
        type: GET_UNLOCKED_BADGE,
        payload
    }
}

export const getUnlockedBadgesSuccess = (payload) => {
    return {
        type: GET_UNLOCKED_BADGE_SUCCESS,
        payload
    }
}

export const getTradeWorkerPerformance = (payload) => {
    return {
        type: GET_WORKER_PERFORMANCE,
        payload
    }
}

export const getTradeWorkerPerformanceSuccess = (payload) => {
    return {
        type: GET_WORKER_PERFORMANCE_SUCCESS,
        payload
    }
}